import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

type Props = RouteComponentProps<{}>;

class ScrollToTop extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 750);
  }

  render() {
    return <>{ this.props.children }</>;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/Shared/ScrollToTop/ScrollToTop.tsx